import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import history from '../history/history';
import { IAuthUserState } from './features/auth/types';
import userAuth from './features/auth';
import { IUserLogoutState } from './features/logout/types';
import userLogout from './features/logout';
import allSurvey from './features/surveys/allSurvey';
import { IAllSurveyState } from './features/surveys/allSurvey/types';
import userInit from './features/userInit';
import { IUserInitState } from './features/userInit/types';
import testData from './features/surveys/testData';
import { TestState } from './features/surveys/testData/types';
import { AddCreateSurveysState } from './features/surveys/createSurveys/types';
import createSurveys from './features/surveys/createSurveys';
import editSurveys from './features/surveys/editSurveys';
import { EditCreateSurveysState } from './features/surveys/editSurveys/types';
import { AddImagesSurveysState } from './features/surveys/addImages/types';
import addImages from './features/surveys/addImages';
import { DeleteImagesSurveysState } from './features/surveys/deleteImagesSurvey/types';
import deleteImagesSurvey from './features/surveys/deleteImagesSurvey';
import { AddCreateQuestionState } from './features/questions/createQuestion/types';
import createQuestion from './features/questions/createQuestion';
import { AllListQuestionState } from './features/questions/allListQuestions/types';
import allListQuestions from './features/questions/allListQuestions';
import { IAllTagState } from './features/surveys/allTag/types';
import allTag from './features/surveys/allTag';
import { IUserInfoState } from 'src/redux/features/userInfo/types';
import userInfo from './features/userInfo';
import { IDuplicateSurveyState } from 'src/redux/features/surveys/duplicateSurvey/types';
import duplicateSurvey from 'src/redux/features/surveys/duplicateSurvey';
import { DeleteSurveyState } from 'src/redux/features/surveys/deleteSurvey/types';
import deleteSurvey from 'src/redux/features/surveys/deleteSurvey';
import { PublishSurveyState } from 'src/redux/features/surveys/changeSurveyStatus/types';
import changeSurveyStatus from 'src/redux/features/surveys/changeSurveyStatus';
import oneSurvey from './features/surveys/oneSurvey';
import { DeleteQuestionState } from './features/questions/deleteQuestion/types';
import deleteQuestion from './features/questions/deleteQuestion';
import { EditQuestionState } from './features/questions/editQuestion/types';
import editQuestion from './features/questions/editQuestion';
import sortedQuestion from './features/questions/sortedQuestion';
import { SortedQuestionState } from './features/questions/sortedQuestion/types';
import { TitleCreateTestType } from './features/surveys/titleCreateTest/types';
import titleCreateTest from './features/surveys/titleCreateTest';
import { IOneSurveyState } from './features/surveys/oneSurvey/types';
import { ITakingSurveyState } from 'src/redux/features/surveys/takingSurvey/types';
import takingSurvey from './features/surveys/takingSurvey';
import { IPutTakingSurveyState } from 'src/redux/features/surveys/putTakingSurvey/types';
import putTakingSurvey from './features/surveys/putTakingSurvey';
import { ImportSurveysState } from './features/surveys/importSurveys/types';
import importSurveys from './features/surveys/importSurveys';
import { IAnalyticState } from 'src/redux/features/analytic/types';
import analytic from 'src/redux/features/analytic';
import unloadSurvey from './features/surveys/unloadSurvey';
import { UnloadSurveyState } from './features/surveys/unloadSurvey/types';
import allMySurvey from './features/surveys/allMySurvey';
import { IAllMySurveyState } from './features/surveys/allMySurvey/types';
import { UnloadExampleState } from './features/surveys/unloadExample/types';
import unloadExample from './features/surveys/unloadExample';

export interface State {
  userAuth: IAuthUserState;
  userLogout: IUserLogoutState;
  testData: TestState;
  createSurveys: AddCreateSurveysState;
  editSurveys: EditCreateSurveysState;
  addImages: AddImagesSurveysState;
  deleteImagesSurvey: DeleteImagesSurveysState;
  createQuestion: AddCreateQuestionState;
  allListQuestions: AllListQuestionState;
  allSurvey: IAllSurveyState;
  userInit: IUserInitState;
  allTag: IAllTagState;
  userInfo: IUserInfoState;
  duplicateSurvey: IDuplicateSurveyState;
  deleteSurvey: DeleteSurveyState;
  changeSurveyStatus: PublishSurveyState;
  oneSurvey: IOneSurveyState;
  deleteQuestion: DeleteQuestionState;
  editQuestion: EditQuestionState;
  sortedQuestion: SortedQuestionState;
  titleCreateTest: TitleCreateTestType;
  takingSurvey: ITakingSurveyState;
  putTakingSurvey: IPutTakingSurveyState;
  importSurveys: ImportSurveysState;
  analytic: IAnalyticState;
  unloadSurvey: UnloadSurveyState;
  allMySurvey: IAllMySurveyState;
  unloadExample: UnloadExampleState;
}

export default combineReducers({
  router: connectRouter(history),
  userAuth,
  userLogout,
  testData,
  allSurvey,
  userInit,
  createSurveys,
  editSurveys,
  addImages,
  deleteImagesSurvey,
  createQuestion,
  allListQuestions,
  allTag,
  userInfo,
  duplicateSurvey,
  deleteSurvey,
  changeSurveyStatus,
  takingSurvey,
  putTakingSurvey,
  oneSurvey,
  analytic,
  deleteQuestion,
  editQuestion,
  sortedQuestion,
  titleCreateTest,
  importSurveys,
  unloadSurvey,
  allMySurvey,
  unloadExample,
});
